import API from '@/api/financeCenter/saleInvoice.js';
/**
 * 处理详情和列表都有的操作
 */
export function commonConfirmAction(type, data, callback) {
  let title;
  let content;
  let url = '';
  if (type == 'delete') {
    url = API.DELETE_DATA;
  }
  if (type == 'withdraw') {
    title = '撤回数据';
    content = '是否确认撤回数据';
    url = API.BATCH_WITHDRAW;
  }
  if (type == 'return') {
    title = '退回数据';
    content = '是否确认退回数据';
    url = API.BATCH_RETURN;
  }
  data = { ids: data.map((it) => it.id) };
  this.$confirmAction(title, content)
    .then(() => {
      this.$axios.post(url, data).then((res) => {
        if (res.data.code === 0) {
          callback();
        } else {
          this.$alert(res.data.msg);
        }
      });
    })
    .catch(() => {});
}

// 批量生成凭证：已提交状态
export function voucherAction(type, data, callback) {
  let url;
  if (type == 'submit') {
    url = API.BATCH_SUBMIT;
  }
  if (type == 'generateVoucher') {
    url = '';
    this.errorTip('待完成功能');
    return;
  }

  this.$axios.post(url, data).then((res) => {
    callback(res);
  });
}

export function handleExport(selectedList, url) {
  const params = this.getQuery();
  delete params.pageNum;
  delete params.pageSize;
  const tableColumn = this.$refs.siruiTable.getTableColumn();
  const showColumns = [];
  tableColumn.visibleColumn.forEach((item) => {
    if (item.property) {
      showColumns.push({ prop: item.property, label: item.title });
    }
  });
  // 一列都没有
  if (tableColumn < 1) {
    let message = this.$t('contractAgency.errorTips.columnEmptyTip');
    this.$message({ showClose: true, message, type: 'error' });
    return;
  }
  // 导出字段
  params.columns = showColumns;
  const prevSelectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
  params.ids = selectedList.concat(prevSelectedList).map((item) => {
    return item.id;
  });
  // 获取数据
  this.$axios.post(url, params).then((res) => {
    if (res.data.code === 0) {
      this.$message({
        showClose: true,
        message: res.data.msg,
        type: 'success',
      });
      window.location.href = res.data.data;
    } else {
      this.$alert(res.data.msg);
    }
  });
}
